export const UPLOAD_LIMITS = {
  employer: {
    proposalVideo: 50 * 1024 * 1024,
    supplementalUpload: 10 * 1024 * 1024,
  },
  student: {
    resumeUpload: 1 * 1024 * 1024,
    supplementalUpload: 10 * 1024 * 1024,
  },
};

const FIELD_LABELS = {
  proposalVideo: 'Project video',
  resumeUpload: 'Resume',
  supplementalUpload: 'Supplemental file',
};

const formatLimitLabel = (bytes) => {
  const mb = bytes / (1024 * 1024);
  return Number.isInteger(mb) ? `${mb} MB` : `${mb.toFixed(1)} MB`;
};

export const getUploadLimitBytes = (fieldName, userType) => {
  const normalizedType = (userType || '').toLowerCase();
  return UPLOAD_LIMITS[normalizedType]?.[fieldName] ?? null;
};

export const getUploadLimitLabel = (fieldName, userType) => {
  const limit = getUploadLimitBytes(fieldName, userType);
  return limit ? formatLimitLabel(limit) : null;
};

export const validateUploadFile = (fieldName, file, userType) => {
  if (!file) return null;

  const limit = getUploadLimitBytes(fieldName, userType);
  if (!limit) return null;

  if (file.size > limit) {
    const label = FIELD_LABELS[fieldName] || 'File';
    return `${label} exceeds the ${formatLimitLabel(limit)} limit. Please choose a smaller file and try again.`;
  }

  return null;
};

export const parseApiErrorResponse = async (response) => {
  const contentType = response.headers.get('content-type') || '';
  if (contentType.includes('application/json')) {
    return response.json();
  }

  const text = await response.text();
  if (!text) return {};

  try {
    return JSON.parse(text);
  } catch (error) {
    if (text.includes('Internal Server Error')) {
      return { error: 'The server encountered an error while processing your upload. Please try again.' };
    }
    return { error: text };
  }
};
